import { parse, ParsedDomain } from 'psl';
import { Capacitor } from '@capacitor/core';
import { Realm, REALM_SWEDEN, REALM_UK } from './constants';

/**
 * https://stackoverflow.com/a/27434991
 * @param host
 */
const isNetworkIp = (host: string) =>
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    host,
  );

export const getBrowserRealm = (): Realm => {
  const defaultLocalEnvRealm = process.env.VITE_OVERRIDE_COUNTRY_CODE || REALM_SWEDEN;

  const host: string = window.location.hostname;
  if (host.endsWith('cloud')) {
    // External call in test
    const match = host.match(/(\w+)(?=\.dev.ilt.cloud)/);
    if (match && match[0]) {
      return match[0] as Realm;
    }
    throw new Error(`Unknown realm for ${host}`);
  }

  if (host.startsWith('localhost') && !Capacitor.isNativePlatform()) {
    // Internal local call
    return defaultLocalEnvRealm as Realm;
  }

  /*
  For running the application on another connected device, serving local files.
   */
  if (isNetworkIp(host)) {
    return defaultLocalEnvRealm as Realm;
  }

  if (host.endsWith('gigletsedu.com')) {
    return REALM_UK;
  }

  if (host.endsWith('quizter.gg')) {
    return REALM_SWEDEN;
  }

  const { tld } = parse(host) as ParsedDomain;
  if (!tld) {
    throw new Error(`Unknown realm for ${host}`);
  }

  switch (tld) {
    case 'co.uk':
      return REALM_UK;
    case 'com':
      return 'us';
    default:
      return tld as Realm;
  }
};
